export default __webpack_public_path__ + "static/media/14.ee4e5ef8.svg";